document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/products/havik2')) return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const heroImageKeywords = [
    'mainimagewithbadge',
    'ChatGPT_Image_Jul_14',
    'Pink_Main_with_Badge'
  ];

  let currentIndex = 0;
  let heroSources = [];
  let timer = null;
  let rotationStopped = false;

  function cleanShopifyUrl(src) {
    if (!src) return null;

    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.delete('width');
      return url.toString();
    } catch (e) {
      return src
        .replace(/_\d+x\d+(?=\.)/g, '')
        .replace(/([?&])width=\d+(&?)/g, '$1')
        .replace(/[?&]$/, '');
    }
  }

  function findHeroSources() {
    const allImages = [...document.querySelectorAll('img')];

    return heroImageKeywords
      .map(keyword => {
        const img = allImages.find(image => {
          const candidates = [
            image.src,
            image.currentSrc,
            image.getAttribute('src'),
            image.getAttribute('srcset')
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

          return candidates.includes(keyword.toLowerCase());
        });

        if (!img) return null;

        const rawSrc =
          img.getAttribute('src') ||
          img.src ||
          img.currentSrc;

        return cleanShopifyUrl(rawSrc);
      })
      .filter(Boolean);
  }

  function preloadImages(urls) {
    urls.forEach(url => {
      const preload = new Image();
      preload.src = url;
    });
  }

  function getFirstSlide() {
    return gallery.querySelector('.product__media-item');
  }

  function isFirstSlideActive() {
    const firstSlide = getFirstSlide();
    return firstSlide?.classList.contains('is-active');
  }

  function rotateHero() {
    if (rotationStopped) return;

    // If shopper is looking at another gallery image, don't interfere
    if (!isFirstSlideActive()) return;

    if (heroSources.length < 2) return;

    currentIndex = (currentIndex + 1) % heroSources.length;

    const firstSlide = getFirstSlide();
    const img = firstSlide?.querySelector('img');

    if (!img) return;

    const newSrc = heroSources[currentIndex];

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = newSrc;
  }

  function stopRotation() {
    rotationStopped = true;

    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function initializeRotation() {
    heroSources = findHeroSources();

    if (heroSources.length < 2) {
      setTimeout(initializeRotation, 750);
      return;
    }

    preloadImages(heroSources);

    if (timer) clearInterval(timer);

    timer = setInterval(rotateHero, 3000);
  }

  initializeRotation();

  /*
   * Stop rotation when customer intentionally clicks
   * a product variant/color option.
   */
  document.addEventListener('click', event => {
    const variantControl = event.target.closest(
      '.product-form__input input[type="radio"], ' +
      '.product-form__input label, ' +
      'variant-selects input, ' +
      'variant-radios input, ' +
      '.swatch, ' +
      '.swatch-input'
    );

    if (variantControl && event.isTrusted) {
      stopRotation();
    }
  });

  /*
   * Also catch dropdown-style variant selectors, if any.
   */
  document.addEventListener('change', event => {
    if (
      event.isTrusted &&
      event.target.closest(
        '.product-form__input, variant-selects, variant-radios'
      )
    ) {
      stopRotation();
    }
  });
});